import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  Typography,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { useTheme } from "@mui/material/styles";
import useMediaQuery from "@mui/material/useMediaQuery";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import parse from "html-react-parser";

const Partners = () => {
  const { t } = useTranslation();
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));

  const partners = [
    {
      id: 1,
      name: t("about_us.partners.partner_list.UoM"),
      desc: t("about_us.partners.partner_list.UoM_desc"),
    },
    {
      id: 2,
      name: t("about_us.partners.partner_list.UA"),
      desc: t("about_us.partners.partner_list.UA_desc"),
    },
    {
      id: 3,
      name: t("about_us.partners.partner_list.UoT"),
      desc: t("about_us.partners.partner_list.UoT_desc"),
    },
    {
      id: 4,
      name: t("about_us.partners.partner_list.UoB"),
      desc: t("about_us.partners.partner_list.UoB_desc"),
    },
    {
      id: 5,
      name: t("about_us.partners.partner_list.UoES"),
      desc: t("about_us.partners.partner_list.UoES_desc"),
    },
    {
      id: 6,
      name: t("about_us.partners.partner_list.UoV"),
      desc: "",
    },
    {
      id: 7,
      name: t("about_us.partners.partner_list.UoK"),
      desc: "",
    },
    {
      id: 8,
      name: t("about_us.partners.partner_list.NEU"),
      desc: t("about_us.partners.partner_list.NEU_desc"),
    },

    {
      id: 9,
      name: t("about_us.partners.partner_list.PTTBI"),
      desc: t("about_us.partners.partner_list.PTTBI_desc"),
    },
    {
      id: 10,
      name: t("about_us.partners.partner_list.WBI"),
      desc: t("about_us.partners.partner_list.WBI_desc"),
    },
    {
      id: 11,
      name: t("about_us.partners.partner_list.TOA"),
      desc: t("about_us.partners.partner_list.TOA_desc"),
    },
    {
      id: 12,
      name: t("about_us.partners.partner_list.PCM"),
      desc: "",
    },
    {
      id: 13,
      name: t("about_us.partners.partner_list.UoN"),
      desc: t("about_us.partners.partner_list.UoN_desc"),
    },
    {
      id: 14,
      name: t("about_us.partners.partner_list.UoMa"),
      desc: "",
    },
    {
      id: 15,
      name: t("about_us.partners.partner_list.UoP"),
      desc: t("about_us.partners.partner_list.UoP_desc"),
    },
  ];

  return (
    <Box>
      <Box
        sx={{
          paddingX: isMobile ? 4 : 24,
          paddingY: isMobile ? 3 : 6,
          backgroundColor: "#f5f5f5",
          borderBottom: "1px solid #eee",
        }}
      >
        <span style={{ color: "#777", marginBottom: "10px", fontSize: "18px" }}>
          {t("homepage.about_project")}
        </span>
        <h1
          style={{
            fontSize: "28px",
            color: "#333",
            letterSpacing: "1px",
            textTransform: "uppercase",
            fontWeight: "600",
            margin: 0,
          }}
        >
          {t("about_us.partners.title")}
        </h1>
      </Box>
      {/* marginBottom: "15px", lineHeight: "1.8", color: "#555" */}
      <Box
        className="content"
        sx={{ paddingX: isMobile ? 4 : 24, paddingY: 3 }}
      >
        <span style={{ color: "#555", fontWeight: "500" }}>
          {t("about_us.partners.our_partners")}
        </span>

        <div style={{ marginTop: 24 }}>
          {partners.map((item) => {
            return (
              <Accordion
                key={item.id}
                defaultExpanded={item.id === 1}
                disabled={item.desc === ""}
                sx={{
                  "&.MuiAccordion-root .Mui-disabled": {
                    backgroundColor: "#FFF",
                    opacity: 1,
                  },
                  "&.MuiAccordion-root .MuiAccordionDetails-root": {
                    backgroundColor: "#FFF",
                    opacity: 1,
                  },
                  marginBottom: "15px",
                }}
              >
                <AccordionSummary
                  expandIcon={item.desc !== "" && <ExpandMoreIcon />}
                >
                  <Typography color={"#3c3636"}>{item.name}</Typography>
                </AccordionSummary>
                <AccordionDetails>
                  <Typography variant="body1" sx={{ textAlign: "justify" }}>
                    {parse(item.desc)}
                  </Typography>
                </AccordionDetails>
              </Accordion>
            );
          })}
        </div>
      </Box>
    </Box>
  );
};

export default Partners;
